module.exports = __webpack_public_path__ + "media/BiointeractiveLogo.4bbd8ce8.svg";


//////////////////
// WEBPACK FOOTER
// ./src/resources/images/credits/BiointeractiveLogo.svg
// module id = 1085
// module chunks = 0